import React from 'react';
import AreaButtonGridPart from '../components/areaButtonGridPart/areaButtonGridPart';
import { IGridPartInternalProps } from '../interface';
import * as S from './styles';

function RowGridPart(props: IGridPartInternalProps) {
  const {
    part,
    isCollumnGrid,
  } = props;

  return (
    <S.Container $show={!isCollumnGrid}>
      <div className="products-list__column products-list__column--partName">
        {part.partName}
      </div>
      <div className="products-list__column products-list__column--category">
        {part.partCategoryName}
      </div>
      <div className="products-list__column products-list__column--subCategory">
        {part.partSubCategoryName}
      </div>
      <div className="products-list__column products-list__column--addToCart">
        <AreaButtonGridPart {...props} />
      </div>
    </S.Container>
  )
}

export default RowGridPart